import { render, staticRenderFns } from "./Vessel.vue?vue&type=template&id=da169ed2&scoped=true"
import script from "./Vessel.vue?vue&type=script&lang=js"
export * from "./Vessel.vue?vue&type=script&lang=js"
import style0 from "./Vessel.vue?vue&type=style&index=0&id=da169ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da169ed2",
  null
  
)

export default component.exports